<template>
  <div id="cat" v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row mb-2">
          <div class="vx-col lg:w-1/3 w-full">
            <label class="vs-select--label">{{ $t("ItemCode") }}</label>
            <vs-input
              name="ItemCode"
              v-model="ItemCode"
              @keyup.enter="searchItemCode()"
            />
          </div>
          <div class="vx-col lg:w-1/6 w-full">
            <vs-button
              class="mt-6 p-2"
              color="success"
              type="gradient"
              icon-pack="feather"
              icon="icon-search"
              @click.prevent="searchItemCode()"
            ></vs-button>
          </div>
        </div>
        <div class="vx-row" v-if="onShowGrid">
          <div class="vx-col w-full mb-2 mt-4">
            <vs-table :data="info" class="custom-tbl">
              <template slot="thead">
                <th style="width: 5%">#</th>
                <th style="width: 40%">{{ $t("SegmentName") }}</th>
                <th style="width: 15%">{{ $t("ID") }}</th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="i" v-for="(index, i) in data">
                  <vs-td>
                    {{ i + 1 }}
                  </vs-td>
                  <vs-td>
                    {{ data[i].name }}
                  </vs-td>
                  <vs-td>
                    {{ data[i].actualProductId }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      ItemCode: "",
      info: [],
      onShowGrid: false
    };
  },
  methods: {
    ...mapActions({
      searchSegmentByItemCOde: "productSegment/searchSegmentByItemCOde"
    }),
    searchItemCode() {
      this.searchSegmentByItemCOde(this.ItemCode).then(r => {
        this.onShowGrid = true;
        this.info = r;
      });
    }
  }
};
</script>
